import { template, className } from "core/decorators";
import { LayoutView } from "marionette";
import iconTemplate from "./icon.template.html";
import MarionetteWrapper from "../../marionette-wrapper-for-react";
import AdapterNativeIcon from "../../../../src/generic/icon/component-icon/adapter-native-icon";

@template(iconTemplate)
class BaseIcon extends LayoutView {
    serializeData() {
        const allowedTypes = [
            "cache",
            "cq",
            "openprocessor",
            "router",
            "source",
            "target",
            "wactionstore",
            "window",
            "stream",
            "ai-agent"
        ];
        let type = this.options.type.toLowerCase();
        const icon = this.options.icon?.toLowerCase();

        if (type === "externalcache") {
            type = "cache";
        }

        if (type === "externalsource") {
            type = "source";
        }

        if (type === "sentinel" || icon === "euclid" || icon === "foreseer" || icon === "sherlock") {
            type = "ai-agent";
        }
        let data = {};
        data.isMirror = this.options?.icon?.endsWith("-mirror");
        data.icon = this.getIcon(this.options.icon, data.isMirror);
        data.type = type;
        data.withBorder = allowedTypes.includes(type);
        data.withBorderClass = allowedTypes.includes(type) ? "with-border" : "";
        data.segmentationIndicator = this.options.segmentationIndicator;
        return data;
    }
}

@className("icon-maker component-icon")
class ComponentIcon extends BaseIcon {}

@className("icon-maker graphnode-icon")
class GraphNodeIcon extends BaseIcon {}

@className("icon-maker sidebar-header-icon")
class SidebarHeaderIcon extends BaseIcon {}

export let iconMaker = {
    createComponentIcon(type, icon, segmentationIndicator) {
        return new ComponentIcon({ type: type, icon: icon, segmentationIndicator: segmentationIndicator });
    },
    createGraphNodeIcon(type, icon) {
        return new GraphNodeIcon({ type: type, icon: icon });
    },
    createSidebarHeaderIcon(type, icon) {
        return new SidebarHeaderIcon({ type: type, icon: icon });
    },
    createSpriteGraphNodeIcon(type, icon, addWrapper = true) {
        const reactIconComponent = MarionetteWrapper(AdapterNativeIcon, {
            name: icon,
            type: type,
            size: 36,
            addWrapper: addWrapper
        });
        return reactIconComponent;
    }
};
